import { useState, useEffect } from "react";
import { NavLink } from 'react-router-dom';
import '../styles/NavBar.css';
import { useAuth } from "../context/AuthContext";
import AuthModal from "./AuthModal";

const NavBar = () => {
    const { user, logout } = useAuth();
    const [showModal, setShowModal] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        if (menuOpen) {
            document.body.classList.add("menu-open");
        } else {
            document.body.classList.remove("menu-open");
        }
    }, [menuOpen]);

    return (
        <header className="navbar">
            <nav>
                <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                    ☰
                </div>

                <ul className={`nav-items ${menuOpen ? "open" : ""}`}>
                    {/* Left-aligned menu items */}
                    <div className="nav-left">
                        <li>
                            <NavLink
                                to="/home"
                                className={({ isActive }) => (isActive ? 'active' : '')}
                                onClick={() => setMenuOpen(false)}
                            >
                                Home
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/predict"
                                className={({ isActive }) => (isActive ? 'active' : '')}
                                onClick={() => setMenuOpen(false)}
                            >
                                Predict
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/leaderboard"
                                className={({ isActive }) => (isActive ? 'active' : '')}
                                onClick={() => setMenuOpen(false)}
                            >
                                Leaderboard
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/points"
                                className={({ isActive }) => (isActive ? 'active' : '')}
                                onClick={() => setMenuOpen(false)}
                            >
                                Points
                            </NavLink>
                        </li>
                        {user ? (
                            <li>
                                <NavLink
                                    to="/squads"
                                    className={({ isActive }) => (isActive ? 'active' : '')}
                                    onClick={() => setMenuOpen(false)}
                                >
                                    Squads
                                </NavLink>
                            </li>
                        ) : ''}
                        <li>
                            <NavLink
                                to="/rules"
                                className={({ isActive }) => (isActive ? 'active' : '')}
                                onClick={() => setMenuOpen(false)}
                            >
                                Rules
                            </NavLink>
                        </li>
                    </div>
                    {/* Right-aligned menu item */}
                    <div className="nav-right">
                        <li>
                            {user ? (
                                <NavLink
                                    to="/profile"
                                    className={({ isActive }) => (isActive ? 'active' : '')}
                                    onClick={() => setMenuOpen(false)}
                                >
                                    {user.username}
                                </NavLink>
                            ) : (
                                <NavLink 
                                    onClick={() => {
                                        setShowModal(true);
                                        setMenuOpen(false);
                                    }}
                                    className={({ isActive }) => (isActive ? "active" : "")} 
                                >
                                    Login/Register
                                </NavLink>
                            )}
                        </li>
                    </div>
                </ul>
            </nav>

            {menuOpen && (
                <div
                    className="backdrop"
                    onClick={() => setMenuOpen(false)}
                />
            )}

            {showModal && <AuthModal closeModal={() => setShowModal(false)} />}
        </header>
    );
};

export default NavBar;
